import {configScrollify, destroyScrollify} from './scrollify-config'

export var scrollifyIsEnabled = false;

if (matchMedia) {
    const mq = window.matchMedia("(min-width : 415px) and (min-height : 737px)");
    mq.addListener(ScreenChange);
    ScreenChange(mq);
}

function ScreenChange(mq) {
    if (mq.matches) {
        configScrollify();
        scrollifyIsEnabled = true;
    } else {
        if (scrollifyIsEnabled) {
            destroyScrollify();
            scrollifyIsEnabled = false;
        } else {
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/js/media-query.js
// module id = OTTz
// module chunks = 0